export class Expressions {
    public static add(
        left: undefined | string,
        right: undefined | string,
        defaultValue: undefined | string
    ): undefined | string {
        if (left == undefined || right == undefined) {
            return defaultValue;
        }
        return (Number(left) + Number(right)).toString();
    }
}
